/**
 * @generated SignedSource<<d6ac070bc476dc17bdf9f6c597bb5d03>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavExpandingAreaItems_seller$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NavExpandingAreaItem_seller" | "NavItem_seller">;
  readonly " $fragmentType": "NavExpandingAreaItems_seller";
};
export type NavExpandingAreaItems_seller$key = {
  readonly " $data"?: NavExpandingAreaItems_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavExpandingAreaItems_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavExpandingAreaItems_seller",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavItem_seller"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavExpandingAreaItem_seller"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "c3fc16ae39f508e4fa533a275810a003";

export default node;
